export const de = {
  // Header Navigation
  nav: {
    home: "STARTSEITE",
    company: "XIAMEN TOWER TECH",
    sourcing: "IMPORT",
    otherServices: "ANDERE DIENSTLEISTUNGEN",
    projects: "PROJEKTE",
    blog: "BLOG",
    partners: "Partner",
    contact: "KONTAKT"
  },
  
  // Hero Section
  hero: {
    title: "Risikofreier Import",
    titleHighlight: "Risikofreier",
    subtitle: "aus China",
    description1: "Vom Werk bis zu Ihrem Lager",
    description1Highlight: "ohne Überraschungen.",
    description2: "Wir überwachen jeden Schritt, damit Ihr Unternehmen",
    description2Highlight: "sorgenfrei wachsen kann.",
    startSourcing: "Import starten",
    learnMore: "Mehr erfahren"
  },

  // About Section
  about: {
    title: "Über Xiamen Tower Technology Co., Ltd.",
    description: "Gegründet 2019 in der Provinz Fujian, China. Wir sind auf die Verbindung internationaler Unternehmen mit zuverlässigen chinesischen Herstellern spezialisiert und gewährleisten Qualität, Effizienz und ein nahtloses Supply-Chain-Management.",
    feature1Title: "Mehrsprachiges Team",
    feature1Description: "Wir sprechen Englisch, Deutsch, Spanisch, Slowenisch und Serbisch und gewährleisten eine klare Kommunikation während des gesamten Prozesses.",
    feature2Title: "Globale Lieferunterstützung",
    feature2Description: "Wir unterstützen Kunden weltweit mit reibungslosem Versand, Logistik und End-to-End-Lieferlösungen.",
    feature3Title: "Verifiziertes Herstellernetzwerk",
    feature3Description: "Wir arbeiten ausschließlich mit vertrauenswürdigen, auditierten Herstellern für konstant hohe Qualität."
  },

  // Services Section
  services: {
    title: "Unsere Dienstleistungen",
    description: "Wir bieten umfassende Lösungen für Ihre Import- und Fertigungsbedürfnisse in China.",
    subtitle: "Wir unterstützen Sie in einer oder mehreren Phasen des Importprozesses",
    mainTitle: "Import-Dienstleistungen",
    sourcingTitle: "Import",
    otherServicesTitle: "Weitere Dienstleistungen",
    sourcingDescription1: "Wir kümmern uns um den gesamten Importprozess: von der Suche nach dem idealen Lieferanten und der Produktentwicklung bis hin zu strengen Qualitätskontrollen und optimierter Logistik.",
    sourcingDescription2: "Mehr als nur ein Vermittler sind wir ein Partner im globalen Einkauf und garantieren Effizienz, Einsparungen und Sicherheit bei jedem Import.",
    otherServicesDescription1: "Wir bieten eine Reihe ergänzender Import-Dienstleistungen, die es Ihnen ermöglichen, Ihre Internationalisierungsprojekte mit Zuversicht anzugehen.",
    otherServicesDescription2: "Von strategischer Beratung bis zum Zugang zu neuen Märkten agiert unser Team als echter Partner für das globale Wachstum Ihres Unternehmens.",
    hideDetails: "Details ausblenden",
    showInfo: "+ INFO",
    moreInfo: "Mehr Informationen",
    process: "Unser Prozess",
    benefits: "Hauptvorteile",
    supplierSelection: {
      title: "Lieferantenauswahl",
      description: "Wir identifizieren und validieren zuverlässige Hersteller in China, die Ihre spezifischen Anforderungen und Qualitätsstandards erfüllen.",
      steps: {
        step1: "Anforderungsanalyse und Marktforschung",
        step2: "Identifikation und Vorauswahl qualifizierter Lieferanten",
        step3: "Fabrikbesuche und technische Bewertungen",
        step4: "Lieferantenverifizierung und Zertifizierungsprüfung"
      },
      benefits: {
        benefit1: "Zugang zu geprüften Premium-Herstellern",
        benefit2: "Minimiertes Risiko durch gründliche Lieferantenprüfung",
        benefit3: "Kürzere Zeit für Lieferantenqualifizierung"
      }
    },
    productDevelopment: {
      title: "Produktentwicklung",
      description: "Wir verwandeln Ihre Idee in ein marktfähiges, hochwertiges Produkt – vom Konzept bis zur Serienproduktion – mit höchsten Standards und Garantien.",
      steps: {
        step1: "Technische Spezifikationen und Designanforderungen",
        step2: "Prototyping und Mustererstellung",
        step3: "Technische Optimierung und Kostenanalyse",
        step4: "Produktionsvorbereitung und Werkzeugentwicklung"
      },
      benefits: {
        benefit1: "Design mit Fokus auf Herstellbarkeit und Skalierbarkeit",
        benefit2: "Schnellere Markteinführung",
        benefit3: "Kontinuierliche Verbesserung durch Marktfeedback"
      }
    },
    qualityControl: {
      title: "Qualitätskontrolle",
      description: "Wir überwachen jede Produktionsphase, um vollständige Konformität, Konsistenz und Exzellenz in jeder Charge sicherzustellen.",
      steps: {
        step1: "Materialprüfung und Vorproduktionskontrolle",
        step2: "Produktionsüberwachung (DUPRO)",
        step3: "Endkontrolle vor dem Versand (PSI)",
        step4: "Detaillierte Berichte mit Fotodokumentation"
      },
      benefits: {
        benefit1: "Früherkennung von Qualitätsproblemen",
        benefit2: "Weniger Rücksendungen und Reklamationen",
        benefit3: "Gleichbleibendes Qualitätsniveau in allen Chargen"
      }
    },
    logisticsManagement: {
      title: "Logistikmanagement",
      description: "Wir koordinieren die gesamte Lieferkette für effiziente und erfolgreiche Importe von China bis zu Ihrem Lager.",
      steps: {
        step1: "Auswahl und Verhandlung mit Logistikpartnern",
        step2: "Zollabwicklung und Exportdokumentation",
        step3: "Containerkonsolidierung und Versandoptimierung",
        step4: "Echtzeit-Tracking bis zur Endlieferung"
      },
      benefits: {
        benefit1: "Optimierte Versandkosten durch intelligente Routenplanung",
        benefit2: "Schnellere Lieferung mit Expressoptionen",
        benefit3: "Vollständige Transportversicherung und Frachtabdeckung"
      }
    }
  },

  // Global Reach Section
  globalReach: {
    title: "Globaler Wirkungskreis",
    description: "Mit unserem starken Lieferantennetzwerk und unserer lokalen Expertise in China unterstützen wir Kunden weltweit mit zuverlässiger Beschaffung, Qualitätsinspektionen und umfassender Projektkoordination in verschiedenen Branchen.",
    feature1Title: "🌍 Bediente Länder",
    feature1Description: "Unterstützung für Kunden in allen wichtigen Weltregionen.",
    feature2Title: "🤝 Internationale Kunden",
    feature2Description: "Vertrauenspartner für Unternehmen in Europa, Amerika, Asien und darüber hinaus.",
    feature3Title: "🏭 Verifiziertes Lieferantennetzwerk",
    feature3Description: "Wir arbeiten ausschließlich mit geprüften und vertrauenswürdigen Herstellern zusammen.",
    feature4Title: "📦 End-to-End-Projektmanagement",
    feature4Description: "Von der Lieferantenauswahl bis zur finalen Lieferung koordinieren wir jeden Schritt."
  },

  // Projects Section
  projects: {
    subtitle: "Produktkategorien",
    title: "Produktkategorien",
    description: "Entdecken Sie unser breites Produktspektrum aus China – sorgfältig ausgewählte Hersteller und zuverlässige Beschaffungslösungen für unterschiedlichste Branchen.",
    contactForDetails: "Kontaktieren Sie uns für detaillierte Produktangebote und technische Spezifikationen",
    viewProducts: "Produkte anzeigen",
    allProjects: "Alle Projekte",
    lookingForSpecific: "Suchen Sie etwas Bestimmtes?",
    lookingDescription: "Unsere Beschaffungsexperten können Ihnen helfen, die richtigen Hersteller und Lieferanten in China für jede Produktkategorie oder individuelle Anforderungen zu finden.",
    contactTeam: "Kontaktieren Sie unser Team",
    viewAllCategories: "Alle Kategorien anzeigen",
    categories: {
      electronics: "ELEKTRONIK",
      machinery: "MASCHINEN",
      tools: "WERKZEUGE",
      packaging: "VERPACKUNG",
      consumer: "KONSUMGÜTER",
      textiles: "TEXTILPRODUKTE",
      apparel: "BEKLEIDUNG & BABYPRODUKTE"
    }
  },

  // Blog Section
  blog: {
    title: "NACHRICHTEN & EINBLICKE",
    description: "Bleiben Sie auf dem Laufenden über Neuigkeiten, Branchentrends und Import-Tipps aus China.",
    chinaExpoNews: "China EXPO Nachrichten",
    expoDescription: "Neueste Updates zu Chinas größten Handelsmessen und Branchenveranstaltungen.",
    industryInsights: "Brancheneinblicke",
    industryInsightsDescription: "Aktuelle Analysen zu Beschaffungstrends und Produktionsinnovationen",
    dailyArticles: "Aktuelles",
    dailyArticlesSubtext: "Frische Branchennews und Einblicke – täglich für Sie",
    refreshAll: "Alle aktualisieren",
    readMore: "Weiterlesen",
    viewAllArticles: "Alle Artikel anzeigen"
  },

  // FAQ Section
  faq: {
    title: "HÄUFIG GESTELLTE FRAGEN",
    subtitle: "Erfolgreicher Import beginnt mit Experten und klar definierten Prozessen.",
    takeAdvantage: "Nutzen Sie die Vorteile des globalen Imports!",
    helpOptimize: "Wir helfen Ihnen, Ihre Lieferkette zu optimieren und Kosten zu senken – bei gleichbleibend hoher Qualität.",
    questions: [
      {
        question: "Warum sollten Sie auf Produktbeschaffung aus China setzen?",
        answer: "China ist der größte Exporteur der Welt und bietet wettbewerbsfähige Preise, technologische Vielfalt und hohe Flexibilität. Mit unserer Unterstützung profitieren Sie von diesen Vorteilen mit Sicherheit und Transparenz."
      },
      {
        question: "Wie gewährleisten Sie Produktqualität?",
        answer: "Wir führen strenge Qualitätsinspektionen in mehreren Phasen durch – vor der Produktion, während der Produktion und vor dem Versand. Unsere Inspektoren sind direkt vor Ort in China und stellen sicher, dass jedes Produkt Ihren Standards entspricht."
      },
      {
        question: "Wie lange dauert der Importprozess?",
        answer: "Der Zeitrahmen variiert je nach Produkt und Menge, liegt jedoch typischerweise zwischen 60 und 90 Tagen, einschließlich Produktion und internationalem Versand. Für dringende Bestellungen bieten wir auch Expressoptionen an."
      },
      {
        question: "Wie funktioniert die Zahlungsabwicklung?",
        answer: "Wir bieten flexible und sichere Zahlungsmethoden an – üblicherweise mit einer Anzahlung und Restzahlung bei Versand. Zahlungen sind per Banküberweisung, Akkreditiv oder anderen vereinbarten Methoden möglich."
      },
      {
        question: "Was sind die Mindestbestellmengen (MOQ)?",
        answer: "Die Mindestbestellmenge hängt vom jeweiligen Produkt und Hersteller ab. Wir können kleine Testmengen ermöglichen und helfen bei der Konsolidierung, um Versandkosten für größere Mengen zu optimieren."
      },
      {
        question: "Welche Produkte können importiert werden?",
        answer: "Wir arbeiten mit einer breiten Produktpalette: Elektronik, Maschinen, Werkzeuge, Verpackungen, Konsumgüter, Textilien, Kleidung und Babyartikel. Kontaktieren Sie uns, wenn Sie ein spezifisches Produkt importieren möchten – wir prüfen die Machbarkeit."
      }
    ],
    successfulImporting: "Erfolgreicher Import beginnt mit einem starken Partner!",
    startProject: "Projekt starten"
  },

  // Contact Section
  contact: {
    title: "Kontaktieren Sie uns",
    description: "Bereit, mit uns zusammenzuarbeiten? Kontaktieren Sie uns, um Ihre Importanforderungen zu besprechen.",
    ourOffice: "Unser Büro",
    phoneLabel: "Telefon",
    emailLabel: "E-Mail",
    locationLabel: "Standort",
    foundedLabel: "Gegründet",
    howHelp: "Wie können wir helfen?",
    requirementsDetail: "Senden Sie uns Ihre Anforderungen, und wir melden uns innerhalb von 24 Stunden.",
    fullName: "Vollständiger Name",
    email: "E-Mail-Adresse",
    company: "Firma (Optional)",
    message: "Nachricht",
    tellUs: "Erzählen Sie uns von Ihren Projektanforderungen...",
    attachFiles: "Dateien anhängen",
    filesSelected: "Datei(en) ausgewählt",
    acceptPrivacy: "Ich akzeptiere die Datenschutzrichtlinie",
    privacyAccept: "Ich habe die Datenschutzerklärung gelesen und akzeptiere diese",
    privacyPolicies: "",
    sendMessage: "Nachricht senden",
    messageSent: "Nachricht erfolgreich gesendet!",
    responseTime: "Wir melden uns innerhalb von 24 Stunden bei Ihnen.",
    validationError: "Validierungsfehler",
    fillRequiredFields: "Bitte füllen Sie alle Pflichtfelder aus.",
    invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    errorTitle: "Fehler",
    errorMessage: "Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt unter office@towertech-xm.com",
    contactForm: "Kontaktformular"
  },

  // Footer
  footer: {
    description: "Ihr vertrauenswürdiger Partner für Qualitätsbeschaffung und Import aus China. Wir verbinden internationale Unternehmen mit zuverlässigen chinesischen Herstellern seit 2019.",
    quickLinks: "Schnellzugriff",
    home: "Startseite",
    about: "Über uns",
    services: "Dienstleistungen",
    projects: "Projekte",
    blog: "Blog",
    contact: "Kontakt",
    legal: "Rechtliches",
    termsOfService: "Nutzungsbedingungen",
    privacyPolicy: "Datenschutzrichtlinie",
    cookiePolicy: "Cookie-Richtlinie",
    gdprCompliance: "DSGVO-Konformität",
    languagesWeSpeak: "Sprachen, die wir sprechen",
    copyright: "© 2024 Xiamen Tower Technology Co., Ltd. Alle Rechte vorbehalten."
  },

  // Languages
  languages: {
    en: "English",
    es: "Español",
    de: "Deutsch",
    sl: "Slovenščina",
    sr: "Српски"
  },

  // UI Common
  ui: {
    hide: "Ausblenden",
    show: "Anzeigen",
    readMore: "Mehr lesen",
    learnMore: "Mehr erfahren",
    getStarted: "Loslegen",
    viewDetails: "Details anzeigen"
  },

  // Products
  products: {
    electronics: {
      solarPanels: {
        name: "Solarmodulsysteme",
        description: "Hocheffiziente mono- und polykristalline Solarmodule für private und gewerbliche Anwendungen"
      },
      electricBikes: {
        name: "Elektrische Fahrräder & Scooter",
        description: "Klappbare E-Bikes und intelligente Scooter mit GPS-Tracking und langlebigen Batterien"
      },
      ledLights: {
        name: "LED-Solarstraßenlampen",
        description: "Kompakte Solarstraßenbeleuchtungssysteme mit Bewegungssensoren und Fernsteuerung"
      },
      powerBanks: {
        name: "Tragbare Solarstrom-Banken",
        description: "Leistungsstarke Solarladestationen für den Außenbereich und Notfälle"
      },
      smartHome: {
        name: "Smart-Home-Geräte",
        description: "WLAN-fähige Thermostate, smarte Steckdosen und Sprachsteuerungssysteme für moderne Haushalte"
      }
    },
    machinery: {
      cncMachining: {
        name: "CNC-Bearbeitungszentren",
        description: "3–5-Achsen-Präzisionsmaschinen für Fertigung und Prototypenbau"
      },
      conveyor: {
        name: "Industrielle Förderbandsysteme",
        description: "Automatisierte Förderbandlinien für Verpackung, Montage und Materialtransport"
      },
      hydraulicPress: {
        name: "Hydraulikpressen",
        description: "Hochleistungs-Hydraulikpressen für Metallumformung und industrielle Anwendungen"
      },
      pneumaticTools: {
        name: "Pneumatische Werkzeuge & Komponenten",
        description: "Komplette pneumatische Systeme einschließlich Kompressoren, Zylindern und Armaturen"
      },
      weldingEquipment: {
        name: "Schweißausrüstung",
        description: "Professionelle MIG/TIG-Schweißgeräte, Plasmaschneider und Schweißzubehör"
      }
    },
    tools: {
      measuring: {
        name: "Präzisionsmessgeräte",
        description: "Digitale Messschieber, Mikrometer und Messuhren für präzise Messungen"
      },
      toolSets: {
        name: "Industrielle Werkzeugsätze",
        description: "Umfassende Mechaniker- und Elektriker-Werkzeugsätze für den professionellen Einsatz"
      },
      powerAccessories: {
        name: "Zubehör für Elektrowerkzeuge",
        description: "Hochwertige Bohrer, Sägeblätter und Schleifscheiben für verschiedene Materialien"
      },
      handTools: {
        name: "Handwerkzeuge",
        description: "Robuste Schraubenschlüssel, Schraubendreher, Zangen und Inbusschlüssel für den täglichen Einsatz"
      },
      safetyEquipment: {
        name: "Sicherheitsausrüstung",
        description: "Professionelle Schutzbrillen, Handschuhe, Helme und Gehörschutz"
      }
    },
    packaging: {
      packagingMachines: {
        name: "Automatische Verpackungsmaschinen",
        description: "Form-Fill-Seal-Maschinen für Lebensmittel-, Pharma- und Konsumgüterverpackungen"
      },
      labelingSystems: {
        name: "Etikettier- & Drucksysteme",
        description: "Industrielle Etikettendrucker und Codiermaschinen zur Produktkennzeichnung"
      },
      sealingEquipment: {
        name: "Versiegelungsanlagen",
        description: "Heißsiegel-, Vakuum- und automatische Klebebandabgabesysteme"
      },
      corrugatedBoxes: {
        name: "Wellpappkartons & Verpackungsschachteln",
        description: "Individuell bedruckte Versandkartons in verschiedenen Größen und Spezifikationen"
      },
      protectivePackaging: {
        name: "Schutzverpackungen",
        description: "Luftpolsterfolie, Schaumstoffeinsätze, Luftkissen und Polstermaterialien"
      }
    },
    consumer: {
      smartAppliances: {
        name: "Smart-Home-Geräte",
        description: "Saugroboter, Luftreiniger und smarte Thermostate für modernes Wohnen"
      },
      furniture: {
        name: "Möbel zum Selbstaufbau",
        description: "Selbstmontage-Schreibtische, Stühle und Aufbewahrungssysteme für Zuhause und Büro"
      },
      kitchenGadgets: {
        name: "Küchengeräte",
        description: "Heißluftfritteusen, Wasserkocher, Küchenmaschinen und innovative Kochgeräte"
      },
      fitnessAccessories: {
        name: "Fitnesszubehör",
        description: "Yogamatten, Widerstandsbänder, Trinkflaschen und Trainingsgeräte"
      },
      phoneAccessories: {
        name: "Handyzubehör",
        description: "Schutzhüllen, kabellose Ladegeräte, Ohrhörer und Gerätehalterungen"
      }
    },
    textiles: {
      technicalFabrics: {
        name: "Technische Stoffe",
        description: "Hochleistungstextilien für industrielle und technische Anwendungen"
      },
      sustainableClothing: {
        name: "Nachhaltige Kleidung",
        description: "Umweltfreundliche Textilien aus Bio-Baumwolle und recycelten Materialien"
      },
      homeTextiles: {
        name: "Heimtextilien",
        description: "Bettwäsche, Handtücher, Vorhänge und Kissenbezüge"
      },
      workwear: {
        name: "Arbeitskleidung",
        description: "Robuste Berufskleidung für Industrie, Handwerk und Dienstleistung"
      },
      cottonProducts: {
        name: "Baumwollprodukte",
        description: "Hochwertige Baumwolltextilien für verschiedene Anwendungen"
      }
    },
    apparel: {
      babyProducts: {
        name: "Babyprodukte & Zubehör",
        description: "Babykleidung, Windeln, Flaschen, Kinderwagen, Autositz und Sicherheitsprodukte"
      },
      kidsClothing: {
        name: "Kinderbekleidung & Schuhe",
        description: "Kinderkleidung, Schuluniformen, Turnschuhe und saisonale Kollektionen"
      },
      adultsFashion: {
        name: "Modebekleidung für Erwachsene",
        description: "Freizeit-, Business- und Sportbekleidung für Damen und Herren sowie Modeaccessoires"
      },
      maternitywear: {
        name: "Umstands- & Stillbekleidung",
        description: "Bequeme Umstandsmode, Still-BHs und Erholungskleidung nach der Geburt"
      },
      seasonalCollections: {
        name: "Saisonkollektionen",
        description: "Wintermäntel, Sommerkleidung, Bademode und festliche Kollektionen für alle Altersgruppen"
      },
      footwearAccessories: {
        name: "Schuhe & Accessoires",
        description: "Schuhe, Stiefel, Handtaschen, Gürtel, Hüte und Modeschmuck für Damen, Herren und Kinder"
      }
    }
  },

  // Cookie Consent Banner
  cookies: {
    bannerTitle: "Wir verwenden Cookies",
    bannerDescription: "Wir verwenden Cookies, um Ihr Browser-Erlebnis zu verbessern, den Website-Traffic zu analysieren und Inhalte zu personalisieren. Durch Klicken auf \"Alle akzeptieren\" stimmen Sie der Verwendung von Cookies zu.",
    acceptAll: "Alle akzeptieren",
    declineOptional: "Optionale ablehnen"
  },

  // Internationale Partner
  partners: {
    title: "Unsere internationalen Partner",
    subtitle: "Vertrauensvolle Partner, die unsere Reichweite erweitern und Kunden in wichtigen globalen Märkten unterstützen.",
    websiteLabel: "Webseite",
    becomePartner: "Interessiert, ein offizieller Vertriebspartner zu werden?",
    contactCta: "Kontakt aufnehmen",
    valsol: {
      tagline: "Vertriebspartner in Chile",
      description: "Offizieller Partner von Xiamen Tower Technology Co., Ltd. für Chile.\nSpezialisiert auf direkte Beschaffung und Importprozesse aus China, mit Fokus auf zuverlässige Lieferkettenlösungen und effektive lokale Marktkoordination."
    }
  }
};